angular.module("datiAnagraficiCessionario.components", []).component("datiAnagraficiCessionario", {
    templateUrl: "ng/components/richiestaCessione/datiAnagraficiCessionario/datiAnagraficiCessionario.view.html",
    bindings: {
        isRichiestaVoltura: "<",
        model: "=",
        exportValidity: "&",
        readOnly: "="
    },
    controllerAs: "datiAnagraficiCessCtrl",
    controller: function DatiAnagraficiCessionario(
        $modalService,
        $timeout,
        $cervedService,
        RiUserG
    ) {
        var self = this;

        self.$onInit = function () {
            self.supportModel = {
                enableModal: false
            }

            self.verifyDatiCessionario();
        }

        self.handleChange = function (property, value) {
            switch (property) {
                case "cervedUpdate":
                    self.model.destinatario = value;
                    self.model.destinatario.updateFromCerved = true;
                    break;
                default:
                    break;
            }
            self.verifyDatiCessionario();
        }

        self.verifyDatiCessionario = function () {
            if (self.model.destinatario.updateFromCerved) {
                self.exportValidity({
                    validity: true
                });
            } else {
                self.exportValidity({
                    validity: false
                });
            }

        }

        self.openModal = function () {
            $cervedService
                .getAppUserCache()
                .then(function (cervedResponse) {
                    if (cervedResponse) {
                        if(cervedResponse.appCustomerUser.metadata.riUserG){
                            self.model.destinatario = cervedResponse.appCustomerUser.metadata.riUserG;
                        }else{
                            self.model.destinatario = RiUserG.build();
                        }
                        
                        self.supportModel.enableModal = true;
                        $timeout(function () {
                            $('.financial-leasing__footer').css("z-index", "-1");
                            $modalService.openModal("showCervedInfosModal");
                        }, 500);
                    }
                })
                .catch(function (error) {
                    console.log(error);
                })
        }

        self.goBackFromCerved = function () {
            $modalService.closeModal("showCervedInfosModal");
            $('.financial-leasing__footer').css("z-index", "1");
            self.supportModel.enableModal = false;
        };
    }
})